export const fr = {
  nav: {
    about:     "À propos de moi",
    projects:  "Mes projets",
    education: "Formations",
    contact:   "Contact",
  },

  hero: {
    title:       "Étudiant Mastère Architecture Logicielle et Ingénierie Informatique",
    subtitle:    "Venez découvrir qui je suis à travers ce portfolio 🌱",
    cv:          "Retrouver mon CV",
    cvDownload:  "Télécharger mon CV",
    cvViewer:    "PDF CV Viewer",
    github:      "GitHub",
    contact:     "Me contacter",
  },

  about: {
    title:   "À propos de moi !",
    iam:     "Je suis :",
    bio:     "Jeune pirate informatique de 23 ans 🏴‍☠️, je navigue sur les mers de la programmation avec envie et passion à la recherche du trésor de la connaissance ⛵.",
    quote:   "\"Le fruit de nos échecs est le composte de notre réussite\" - 2019",
    author:  "Ziadi Noé 🍂",
    linkedin: "Retrouvez moi sur LinkedIn →",
    texts: [
      "Développeur Full Stack 💻",
      "Alternant chez Moovijob 😍",
      "Ancien alternant chez CHAUSSEA 👟",
      "Futur Ingénieur I.A 🤖",
      "En train de dormir 😴",
      "Error 404 [Human not found]",
      "Plus fort que toi sur PixelWar 🖼️",
    ],
  },

  projects: {
    title:       "Mes projets !",
    learnMore:   "En savoir plus →",
    unavailable: "⛔ Indisponible",
  },

  education: {
    title: "Formations !",
  },

  skills: {
    title: "Mes compétences techniques !",
  },

  footer: {
    rights: "Tous droits réservés.",
  },
};
